import React, { useState } from 'react';
import { generateRandomId } from '../../../utils/string';
import { Button, Form, Modal } from '@themesberg/react-bootstrap';
import { useTranslation } from 'react-i18next';
import { isValidVehicleNumber } from '../../../utils/vehicles';
import { getVehicleDetailsByNumber } from '../../../parse-functions/vehicles';
import EditableDropDown from '../../../components/common/EditableDropdown';
import { useSelector } from 'react-redux';
// import { returnZoneDropdownOptions } from '../../../utils/zone';
import { arrayToDropdownOptions } from '../../../utils/sms/arrayToDropdownOptions';
import { returnWarehouseDropdownOptions } from '../../../utils/warehouse';
import { ErrorMessage } from '../../scheme-management/Components/StyledComponents';
const Joi = require('joi');

const driverDetailsSchema = Joi.object({
  vehicleNumber: Joi.string()
    .trim()
    .required()
    .custom((value, helpers) => {
      if (!isValidVehicleNumber(value)) {
        return helpers.error('any.custom');
      }
      return value;
    })
    .messages({
      'any.custom': 'Invalid vehicle number format',
      'string.empty': 'Vehicle number must not be empty',
      'any.required': 'Vehicle number is required',
    }),
  driverName: Joi.string().trim().required(),
  contactNumber: Joi.string().trim().required(),
  storeName: Joi.string().trim().required(),
  vehicleType: Joi.string().trim().required(),
});

const EntryModal = (props) => {
  const { showModal, closeModal, handleSubmit, zone, vendorOptions } = props;
  const { t } = useTranslation();
  const [modalValue, setModalValue] = useState({ vehicleNumber: '', zone });
  // const zones = useSelector((state) => state?.user?.config?.zones || {});
  const otherWarehouses = useSelector(
    (state) => state?.user?.otherWarehousesInZone || {}
  );
  const storeName = useSelector(
    (state) => state?.user?.warehouse?.warehouseName || ''
  );
  const isAdmin = useSelector(
    (state) => state?.user?.preferences?.isAdmin || false
  );
  const [errors, setErrors] = useState({});
  const [vehicleData, setVehicleData] = useState({});
  const [driverDetails, setDriverDetails] = useState({});
  const configData = useSelector((state) => state.user.config || {});

  const handleChange = (event, key) => {
    setModalValue((prev) => ({ ...prev, [key]: event }));
    setErrors({});
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    const fieldName = 'vehicleNumber';
    let value = modalValue?.vehicleNumber;
    // let zoneValue = zone ? zone : modalValue?.zone;
    if (value !== 0 && !modalValue[fieldName]) {
      setErrors({ [fieldName]: 'please enter vehicle No' });
      return;
    }

    try {
      isValidVehicleNumber(value);
    } catch (error) {
      setErrors({ [fieldName]: 'Vehicle Number format is incorrect' });
      return;
    }
    const data = { vehicleNumber: value };

    try {
      const res = await getVehicleDetailsByNumber(data);
      setDriverDetails({
        vehicleNumber: res?.vehicleNumber,
        driverName: res?.driverName,
        contactNumber: res?.contactNumber?.toString(),
        vendorName: res?.vendorName,
        vendorObjectId: res?.vendorObjectId,
        vehicleType: res?.vehicleType,
        storeName,
      });
      setVehicleData(res);
    } catch (error) {
      setVehicleData({});
      setErrors({ [fieldName]: 'Vehicle Number not in the System.' });
      return;
    }

    setErrors({});
    setModalValue({ [fieldName]: '' });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const { error } = driverDetailsSchema.validate(driverDetails, {
      abortEarly: false,
      allowUnknown: true,
    });

    const errors = {};
    if (error) {
      error.details.forEach((detail) => {
        errors[detail.path[0]] = detail.message;
      });
    }
    console.log(errors);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    try {
      await handleSubmit({ ...vehicleData, ...driverDetails });
    } catch (error) {
      return;
    }
    setVehicleData({});
    setDriverDetails({});
    setErrors({});
  };

  const handleCloseModal = () => {
    closeModal();
    setDriverDetails({});
    setVehicleData({});
    setErrors({});
  };
  return (
    <>
      <Modal
        id={generateRandomId()}
        as={Modal.Dialog}
        centered
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title className="h6">{t('Registration Entry')}</Modal.Title>
          <div className="d-flex gap-2 align-items-center">
            <Form.Group controlId="formTemporaryDriver">
              <Form.Check
                type="checkbox"
                checked={!!driverDetails?.temporary}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setDriverDetails({
                    temporary: checked,
                    storeName,
                  });
                }}
                label="Add Temporary"
              />
            </Form.Group>
            <Button
              variant="close"
              aria-label="Close"
              onClick={handleCloseModal}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {!driverDetails.temporary ? (
            <>
              <Form onSubmit={handleSubmitClick}>
                <Form.Group className="mb-3">
                  <Form.Label>{t('Enter Vehicle No')}</Form.Label>
                  <div className={`d-flex gap-3 `}>
                    <span className="w-100">
                      <Form.Control
                        required
                        type="text"
                        isInvalid={!!errors['vehicleNumber']}
                        onChange={(e) =>
                          handleChange(e.target.value, 'vehicleNumber')
                        }
                        // width={'250px'}
                      />
                      {errors['vehicleNumber'] && (
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ display: 'block' }}
                        >
                          {errors['vehicleNumber']}
                        </Form.Control.Feedback>
                      )}
                    </span>
                    {/* {!zone && (
                  <EditableDropDown
                    options={returnZoneDropdownOptions(zones)}
                    onChange={(value) => {
                      handleChange(value.id, 'zone');
                    }}
                    width={'100%'}
                  />
                )} */}
                    <Button
                      variant="primary"
                      style={{ height: '40px' }}
                      onClick={handleSubmitClick}
                    >
                      {t('Submit')}
                    </Button>
                  </div>
                </Form.Group>
              </Form>
              {Object.keys(vehicleData).length > 0 && (
                <div className="d-flex flex-column gap-3">
                  <Form.Group>
                    {t(`Driver Name : `)}
                    <Form.Control
                      value={driverDetails?.driverName}
                      isInvalid={!!errors['driverName']}
                      onChange={(e) => {
                        const { value } = e.target;
                        setDriverDetails((prev) => {
                          return {
                            ...prev,
                            driverName: value,
                          };
                        });
                        setErrors((prev) => {
                          return {
                            ...prev,
                            driverName: null,
                          };
                        });
                      }}
                      type={'text'}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors['driverName']}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group>
                    {t(`Phone Number : `)}
                    <Form.Control
                      value={driverDetails?.contactNumber}
                      isInvalid={!!errors['contactNumber']}
                      onChange={(e) => {
                        const { value } = e.target;
                        setDriverDetails((prev) => {
                          return {
                            ...prev,
                            contactNumber: value,
                          };
                        });
                        setErrors((prev) => {
                          return {
                            ...prev,
                            contactNumber: null,
                          };
                        });
                      }}
                      type={'number'}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors['contactNumber']}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Vendor Name</Form.Label>
                    <EditableDropDown
                      id={'vendor'}
                      onChange={(e) => {
                        setDriverDetails((prev) => ({
                          ...prev,
                          vendorName: e.value,
                          vendorObjectId: vendorOptions[e.value],
                        }));
                      }}
                      backgroundColor="#eaedf2"
                      value={driverDetails['vendorName']}
                      options={arrayToDropdownOptions(
                        Object.keys(vendorOptions)
                      )}
                      placeholder={'Select Vendor Name'}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors['vendorName']}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Store Name</Form.Label>
                    <EditableDropDown
                      id={'warehouses'}
                      onChange={(e) =>
                        setDriverDetails((prev) => ({
                          ...prev,
                          storeName: e.value,
                        }))
                      }
                      backgroundColor="#eaedf2"
                      value={driverDetails['storeName']}
                      options={returnWarehouseDropdownOptions(otherWarehouses)}
                      placeholder={'Select Store Name'}
                      isInvalid={errors['storeName']}
                      disabled={!isAdmin}
                    />
                    <ErrorMessage>{errors['storeName']}</ErrorMessage>
                  </Form.Group>
                  <Form.Group>
                    {t(`Vehicle Type : `)}
                    <Form.Control
                      value={vehicleData?.vehicleType}
                      disabled={true}
                      type={'text'}
                    />
                  </Form.Group>
                </div>
              )}
            </>
          ) : (
            <>
              <Form.Group>
                {t(`Vehicle Number : `)}
                <Form.Control
                  value={driverDetails?.vehicleNumber}
                  isInvalid={!!errors['vehicleNumber']}
                  onChange={(e) => {
                    const { value } = e.target;
                    setDriverDetails((prev) => {
                      return {
                        ...prev,
                        vehicleNumber: value,
                      };
                    });
                  }}
                  type={'text'}
                />
                <Form.Control.Feedback type="invalid">
                  {errors['vehicleNumber']}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                {t(`Driver Name : `)}
                <Form.Control
                  value={driverDetails?.driverName}
                  isInvalid={!!errors['driverName']}
                  onChange={(e) => {
                    const { value } = e.target;
                    setDriverDetails((prev) => {
                      return {
                        ...prev,
                        driverName: value,
                      };
                    });
                  }}
                  type={'text'}
                />
                <Form.Control.Feedback type="invalid">
                  {errors['driverName']}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                {t(`Phone Number : `)}
                <Form.Control
                  value={driverDetails?.contactNumber}
                  isInvalid={!!errors['contactNumber']}
                  onChange={(e) => {
                    const { value } = e.target;
                    setDriverDetails((prev) => {
                      return {
                        ...prev,
                        contactNumber: value,
                      };
                    });
                    setErrors((prev) => {
                      return {
                        ...prev,
                        contactNumber: null,
                      };
                    });
                  }}
                  type={'number'}
                />
                <Form.Control.Feedback type="invalid">
                  {errors['contactNumber']}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>Store Name</Form.Label>
                <EditableDropDown
                  id={'warehouses'}
                  onChange={(e) =>
                    setDriverDetails((prev) => ({
                      ...prev,
                      storeName: e.value,
                    }))
                  }
                  backgroundColor="#eaedf2"
                  value={driverDetails['storeName']}
                  options={returnWarehouseDropdownOptions(otherWarehouses)}
                  placeholder={'Select Store Name'}
                  isInvalid={errors['storeName']}
                  disabled={!isAdmin}
                />
                <ErrorMessage>{errors['storeName']}</ErrorMessage>
              </Form.Group>
              <Form.Group>
                <Form.Label>Vehicle Type</Form.Label>
                <EditableDropDown
                  id={'vehicleType'}
                  onChange={(e) =>
                    setDriverDetails((prev) => ({
                      ...prev,
                      vehicleType: e.value,
                    }))
                  }
                  backgroundColor="#eaedf2"
                  value={driverDetails['vehicleType']}
                  options={arrayToDropdownOptions(
                    configData.manualEntryVehicles
                  )}
                  placeholder={'Select Vehicle Type'}
                  isInvalid={errors['vehicleType']}
                />
                <ErrorMessage>{errors['vehicleType']}</ErrorMessage>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            type="submit"
            onClick={handleSave}
            disabled={
              !vehicleData?.temporary && Object.keys(driverDetails).length === 0
            }
          >
            {t('Update/Register Entry')}
          </Button>
          <Button
            variant="link"
            className="text-gray ms-auto"
            onClick={handleCloseModal}
          >
            {t('Cancel')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EntryModal;
